module.exports = __webpack_public_path__ + "img/277e051ca1954fed349172cfd779e615.png";